<!-- src/components/Notification.vue -->
<template>
    <div class="notification"
         :class="[typeClass, {'closing': isClosing, 'hovering': isHovering}]"
         @mouseenter="handleMouseEnter"
         @mouseleave="handleMouseLeave"
         @click="dismiss"
         @mousedown="handleMouseDown"
         @mouseup="handleMouseUp">
        <button class="dismiss-btn" @click.stop="dismiss">
            <i class="fas fa-times"></i>
        </button>
        <div class="icon-container">
            <i :class="iconClass"></i>
        </div>
        <div class="Ncontent">
            <div class="notification-message">{{ message }}</div>
        </div>
        <div class="progress-bar" v-if="showProgress">
            <div class="progress" :style="{ width: progressWidth }"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            message: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'info',
                validator: value => ['error', 'warning', 'info', 'success'].includes(value)
            },
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                isClosing: false,
                isHovering: false,
                isMouseDown: false,
                showProgress: true,
                progressWidth: '100%',
                timeoutId: null,
                animationId: null,
                startTime: 0,
                initialDuration: 0,
                remainingTime: 0,
                timeFactor: 1
            };
        },
        computed: {
            typeClass() {
                return `notification-${this.type}`;
            },
            iconClass() {
                const icons = {
                    error: 'fas fa-exclamation-circle',
                    warning: 'fas fa-exclamation-triangle',
                    info: 'fas fa-info-circle',
                    success: 'fas fa-check-circle'
                };
                return icons[this.type];
            }
        },
        mounted() {
            this.startAutoDismiss();
        },
        beforeUnmount() {
            this.cancelAnimations();
        },
        methods: {
            startAutoDismiss() {
                const charsPerSecond = 15;
                const baseDuration = 5000;
                this.initialDuration = Math.max(
                    5000,
                    baseDuration + (this.message.length / charsPerSecond) * 1000 * 1.2
                );
                this.remainingTime = this.initialDuration;
                this.startTime = Date.now();
                this.updateProgress();
            },

            updateProgress() {
                const now = Date.now();
                const elapsed = now - this.startTime;

                // Ӧ��ʱ������
                const effectiveElapsed = elapsed * this.timeFactor;
                this.remainingTime = Math.max(0, this.initialDuration - effectiveElapsed);

                this.progressWidth = `${(this.remainingTime / this.initialDuration) * 100}%`;

                if (this.remainingTime > 0) {
                    this.animationId = requestAnimationFrame(this.updateProgress);
                } else {
                    this.dismiss();
                }
            },

            handleMouseEnter() {
                this.isHovering = true;
                // ����ʱ������ (��ʵ1�� = ����ʱ0.3��)
                this.timeFactor = 0.3;
                this.startTime = Date.now(); // ���ü�ʱ���
            },

            handleMouseLeave() {
                this.isHovering = false;
                // �ָ�����ʱ������
                this.timeFactor = 1;
                this.startTime = Date.now(); // ���ü�ʱ���
            },

            handleMouseDown() {
                this.isMouseDown = true;
            },

            handleMouseUp() {
                this.isMouseDown = false;
            },

            dismiss() {
                if (this.isClosing) return;
                this.isClosing = true;
                this.showProgress = false;
                this.cancelAnimations();

                setTimeout(() => {
                    this.$emit('dismiss', this.id);
                }, 300);
            },

            cancelAnimations() {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                if (this.animationId) {
                    cancelAnimationFrame(this.animationId);
                    this.animationId = null;
                }
            }
        }
    };
</script>

<style scoped>
    .notification {
        display: flex;
        align-items: flex-start;
        background-color: #f8f9fa;
        border-left: 4px solid #6c757d;
        color: #343a40;
        padding: 12px 40px 12px 16px;
        border-radius: 6px;
        position: relative;
        min-width: 100px;
        max-width: min(400px,70vw);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
        transform-origin: top right;
        overflow: visible;
        cursor: pointer;
        transform: scale(1);
        flex-shrink: 0;
        /* ȷ��֪ͨ���ᱻ�ü� */
        z-index: 1; /* �����㼶 */
    }

        .notification.hovering {
            transform: scale(1.05);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
            z-index: 100; /* �����㼶ȷ���ڶ��� */
        }

        .notification:active {
            transform: scale(0.98) translateY(2px);
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }

    .icon-container {
        margin-right: 12px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        transition: transform 0.2s ease;
        flex-shrink: 0; /* ��ֹ���� */
    }

    .notification.hovering .icon-container {
        transform: scale(1.2);
    }

    .Ncontent {
        padding: 20px;
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        min-width: 0; /* �����ı��ض� */
    }

    .notification-message {
        margin: 0;
        font-size: 14px;
        line-height: 1.4;
        padding-right: 10px;
        transition: transform 0.2s ease;
        /* ȷ���ı�����ſ�֪ͨ */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal; /* ���������ı� */
        word-break: break-word; /* �������Զ����� */
        flex: 1;
        min-width: 0; /* �������� */
    }

    .notification.hovering .notification-message {
        transform: translateX(2px);
    }

    .dismiss-btn {
        background: none;
        border: none;
        color: inherit;
        cursor: pointer;
        opacity: 0.7;
        transition: all 0.2s ease;
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 3;
        flex-shrink: 0; /* ��ֹ���� */
    }

        .dismiss-btn:hover {
            opacity: 1;
            transform: scale(1.1);
        }

    /* ��������ʽ */
    .progress-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 0 0 6px 6px;
        overflow: hidden;
    }

    .progress {
        height: 100%;
        transition: width 0.1s linear;
    }

    /* �رն��� */
    .notification.closing {
        opacity: 0;
        transform: scale(0.8) translateX(20px);
    }

    /* ��ͬ������ʽ */
    .notification-error {
        background-color: #f8d7da;
        border-color: #dc3545;
        color: #721c24;
    }

        .notification-error .progress {
            background: #dc3545;
        }

    .notification-warning {
        background-color: #fff3cd;
        border-color: #ffc107;
        color: #856404;
    }

        .notification-warning .progress {
            background: #ff9400;
        }

    .notification-info {
        background-color: #e2e3e5;
        border-color: #0dcaf0;
        color: #055160;
    }

        .notification-info .progress {
            background: #0dcaf0;
        }

    .notification-success {
        background-color: #d1e7dd;
        border-color: #198754;
        color: #0f5132;
    }

        .notification-success .progress {
            background: #198754;
        }
</style>